module.exports = __webpack_public_path__ + "static/media/illustration-mobile.94e3588d.svg";